import { SET_CONTENT_LOADING } from './actionTypes'

const setFiletraceContentLoading = (loadingStatus) => {
    return {
        type : SET_CONTENT_LOADING,
        info : "Filetrace redux action :",
        loadingStatus : loadingStatus
    }
}

export default setFiletraceContentLoading;